import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useState } from "react";
import postDataTrace from "../../../../services/postDataTrace";
import getBase64 from "../../../../utils/getBase64";

export default function UpdateSign({
  isVisible,
  setVisible,
  refetch,
  selected,
}: any) {
  const [isLoading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState();

  const [form] = Form.useForm();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const onSubmit = async () => {
    setLoading(true);
    let base64 = null;
    if (selectedFile) {
      base64 = await getBase64(selectedFile);
    }
    const data = {
      signature: base64,
    };
    const uri = `users/${selected?._id}/signature/update`;
    const response = await postDataTrace(data, uri);
    if (response.success) {
      message.success("Uploaded Successfully");
      refetch();
      form.resetFields();

      setVisible(false);
    } else {
      message.error(response.message);
    }
    setLoading(false);
  };

  const clearForm = async () => {
    form.resetFields();
    setLoading(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Update Signature"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateUserSignature"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateUserSignature"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="file"
              label="Signature"
              rules={[
                {
                  required: false,
                  message: "Please select file",
                },
              ]}
            >
              <Input
                type="file"
                accept="image/png, image/gif, image/jpeg, image/jpg"
                placeholder="Signature"
                onChange={changeHandler}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
